let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cBy9y")).then(() => parcelRequire('iV0NL'));